module.exports = __webpack_public_path__ + "img/SwissTrust1.ebe80bee.png";